module.exports = __webpack_public_path__ + "img/banner05_img.07931d13.png";